import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {aboutData.title}
          </h2>
          <div className="mt-3 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="rounded-xl overflow-hidden">
              <img
                src={aboutData.imageUrl}
                alt="爱丫爱丫影院平台介绍"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-4">
              你的专属免费高清影视入口
            </h3>
            <p className="text-foreground-600 leading-relaxed text-base">
              {aboutData.description}
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-10 h-10 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-movie-line text-xl"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">海量片库</div>
                  <div className="text-xs text-foreground-500">3500+剧集</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-10 h-10 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-speed-up-line text-xl"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">极速秒开</div>
                  <div className="text-xs text-foreground-500">无需等待</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-10 h-10 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-smartphone-line text-xl"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">多端适配</div>
                  <div className="text-xs text-foreground-500">手机电脑平板</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
                <span className="w-10 h-10 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-shield-check-line text-xl"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">完全免费</div>
                  <div className="text-xs text-foreground-500">无需注册</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}